"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const array_1 = require("./utils/array");
exports.DatagridTableView = (props) => {
    return (React.createElement("div", { className: "grid-tbody" },
        !!props.children.length && React.createElement("div", { className: "grid-trs" }, props.children),
        (!props.children.length || props.children.length < 20) && renderPlaceholder(props)));
};
exports.DatagridTableView.displayName = 'DatagridTableView';
exports.DatagridTableView.defaultProps = {
    loading: false,
    showPlaceholderCells: false,
};
const renderPlaceholder = (props) => {
    const { showPlaceholderCells, properties, loading } = props;
    const dummyArray = array_1.range(100);
    return (React.createElement("div", { className: "grid-trs-placeholders" }, dummyArray.map((item, index) => (React.createElement("div", { key: index, className: "grid-tr" }, properties.map((property, index) => (React.createElement("div", { key: index, className: classNames('grid-td grid-td-placeholder', { loading }), style: property.thStyle }))))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridTableView.tsx
// module id = 256
// module chunks = 0